import styles from "./css/AlternativeCard.module.css";
import { AlternativeData } from "@/types/alternative";
import ProjectImageNotFound from "@/assets/projectImageNotExists.png";
import TruncateText from "../addons/TruncatedText";
import { formatDateWithTime } from "@/utils/date";
import { PencilWriting } from "@/icons/PencilWriting";
import { FavoriteIcon } from "@/icons/FavoriteIcon";
import { useNavigate, useParams } from "react-router-dom";
import { GreenLightningIcon } from "@/icons/GreenLightningIcon";

interface AlternativeCardProps {
    alternative: AlternativeData
    isFavourite: boolean;
    setFavourite: (id: string, isFavourite: boolean) => void;
    isChecked?: boolean;
    onCheck?: (alternative: AlternativeData, checked: boolean) => void;
    isSelected: boolean;
    onSelect: (isSelected: boolean) => void;
    isBestAlternative: boolean;
}
export const AlternativeCard = ({
    alternative, 
    isFavourite, 
    setFavourite,
    isChecked = false,
    onCheck,
    isSelected = false,
    onSelect,
    isBestAlternative = false
}: AlternativeCardProps) => {
    const navigate = useNavigate();
    const {entityName, projectId, cityId} = useParams<{entityName: string, projectId: string, cityId: string}>();

    const handleEditAlternative = () => {
        navigate(`/${entityName}/project/${cityId}/${projectId}/alternative/${alternative.id}/update`);
    }
    return (
        <div 
            className={`${styles.container} ${isSelected ? styles.selected : ''}`}
            onClick={(prev) => {
                onSelect(!prev);
            }}
        >
            <input 
                type="checkbox"
                checked={isChecked}
                onChange={(e) => onCheck?.(alternative, e.target.checked)}
                onClick={(e) => e.stopPropagation()}
                className={styles.checkbox}
            />
            <div className={styles.img}>
                {/* {alternative?.files?.image && (
                    <img 
                        src={alternative.files.image} 
                        alt="alternative" 
                        className={styles.projectImage}
                    />
                )} */}
                {!alternative?.files?.image && (
                    <img src={ProjectImageNotFound} alt="alternative-missing image" />
                )}
            </div> 
            <div className={styles.info}>
                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                <h1 className={styles.name}>{TruncateText({text: alternative.name, maxLength: 23})}</h1>
                {isBestAlternative && <GreenLightningIcon size="16" tooltip="האלטרנטיבה העדיפה אנרגטית" />}
                {(alternative as any).needs_recalculation && (
                    <span className={styles.warningBadge} title="דורש עדכון - שנת היעד שונתה">
                        ⚠️
                    </span>
                )}
                </div>
                <div className={styles.createdAtDiv}>
                <p className={styles.createdAt}>{ formatDateWithTime(alternative.created_at) + " "}</p>
                <p >עדכון קבצים אחרון</p>

                </div>
                <p className={styles.createdBy}>{alternative.created_by}</p>
            </div>     
            <div className={styles.actions}>
                <button className={styles.editButton} onClick={(e) => {e.stopPropagation(); handleEditAlternative()} }>
                    <PencilWriting className={styles.editIcon} />
                </button>
                <div onClick={(e) => {e.stopPropagation(); setFavourite(alternative.id, !isFavourite)} } className="cursor-pointer">
                    <FavoriteIcon isFavourite={isFavourite}/>
                </div>
            </div>
        </div>
    );
}